module.exports = __webpack_public_path__ + "img/square-question.6c48df4a.svg";